// retention-path.ts — operator visuals G6: the pure geometry behind the retention chart (kept apart from the
// component so it tests without the API client).
/** The SVG path for a curve in a w×h box (x = seconds over the longest curve, y = retained 0..1). Pure. */
export function curvePath(points: { second: number; retained: number }[], maxSec: number, w: number, h: number): string {
  if (points.length === 0 || maxSec <= 0) return "";
  return points.map((p, i) => `${i ? "L" : "M"}${((p.second / maxSec) * w).toFixed(1)},${((1 - Math.max(0, Math.min(1, p.retained))) * h).toFixed(1)}`).join(" ");
}
